import React from 'react';
import PropTypes from 'prop-types';
import { tracksColors } from "../../config/styles";
import TrackStatusIcon from "../UI/Icons/TrackStatusIcon";
import TrackDifficultyIcon from "../UI/Icons/TrackDifficultyIcon";
import { t } from "../../lang/trans";

const PopupTrackContent = ({ title, trackStatus, trackInfo }) => (
	<div className="popup-content popup-content-track">
		<h3 className="popup-content__track-title">
			<TrackStatusIcon status={trackStatus}/>

			{(trackInfo.notes && Array.isArray(trackInfo.notes) && trackInfo.notes.some(note => note.id === 9)) ? t('навчальний майданчик') : t('траса')} {title}
		</h3>

		{(trackInfo.notes && Array.isArray(trackInfo.notes) && trackInfo.notes.length > 0) && (
			<div className="popup-content__info-text">
				{trackInfo.notes.map((note, index) => <div key={'note' + index}>{note.text}</div>)}
			</div>
		)}

		<div className="popup-content__track-table-wrap">
			<table className="popup-content__track-table">
				<thead>
				<tr>
					<th>{t('тип складності')}</th>
					<th>{t('верхня висота, м')}.</th>
					<th>{t('нижня висота, м')}.</th>
					<th>{t('довжина траси, м')}.</th>
				</tr>
				</thead>

				<tbody>
				<tr>
					<td>
						<div style={{ marginTop: 2 }}>
							<TrackDifficultyIcon color={tracksColors[trackInfo.difficulty] || (trackInfo.difficulty === 'green' ? '#4CAF50' : '#000')}/>
						</div>
					</td>
					<td>{trackInfo.topHeight}</td>
					<td>{trackInfo.bottomHeight}</td>
					<td>{trackInfo.length}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
);

PopupTrackContent.defaultProps = {
	trackInfo: {
		topHeight: 1110,
		bottomHeight: 897,
		length: 915
	}
};

PopupTrackContent.propTypes = {
	trackInfo: PropTypes.shape({
		topHeight: PropTypes.any,
		bottomHeight: PropTypes.any,
		length: PropTypes.any
	})
};

export default PopupTrackContent;
